import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

export default function ScrollToTop({ children }) {
  const prevPathname = useRef();
  const { pathname, hash } = useLocation();

  const doScroll = () => {
    if (!hash || hash.trim().length === 0) {
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    doScroll();
  }, []);

  useEffect(() => {
    if (pathname !== prevPathname.current) {
      prevPathname.current = pathname;
      doScroll();
    }
  }, [pathname]);

  return children;
}
